// extracted by mini-css-extract-plugin
module.exports = {"all_equipment":"ClassDifferences_all_equipment__PJU3I","single_equipment":"ClassDifferences_single_equipment__2apwR"};